const LoginBg = () => {
  return (
    <div
      className="font-darker h-dvh w-screen px-4 pt-6 text-white "
      style={{
        background: "url('/images/auth-img.png')",
      }}
    >
      <h1 className="pr-12 text-[40px] leading-12 font-extrabold md:text-7xl">
        Transact the My-Pay Way
      </h1>
      <p className="mt-4 text-xl font-semibold md:text-3xl">
        Create and manage virtual cards for all your online transactions
        subscriptions and bills
      </p>

      <img src="/images/login-icon-set.svg" className="mt-6 md:w-40" alt="" />

      <img
        className="absolute top-2/4 left-1/2 -translate-x-1/2 right-0 z-10 w-4/5 min-w-80 -translate-y-1/3 md:w-[600px]"
        src="/images/login-atm.svg"
        alt="Atm cards"
      />

      {/* <img
        src="/images/login-bg-line.svg"
        alt=""
        className="absolute inset-x-0 bottom-0 z-0 w-full"
      /> */}
    </div>
  );
};

export default LoginBg;
